import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
    isFetching: false,
    isEditSuccess: false,
    isError: false,
    errorMessage: '',
};

export const UserEditPassword = createAsyncThunk(
    'auth/changePassword',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            const response = await axios.patch('/api/auth/changePassword', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

            let data = response.data;
            // console.log(data)
            if (response.status === 200) {
                return data;
            }
            else if (response.status === 201) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);

export const editPasswordSlice = createSlice({
    name: 'editPassword',
    initialState,
    reducers: {
        clearStateEditPassword: (state, { payload }) => {
            state.isError = false;
            state.isFetching = false;
            state.errorMessage = '';
            state.isEditSuccess = false;
        },
    },

    extraReducers: {
        [UserEditPassword.fulfilled]: (state, { payload }) => {
            if (payload.success == false) state.isError = true;
            else state.isError = false;
            if (payload.success) state.isEditSuccess = true;
            if (payload.message) state.errorMessage = payload.message;
            else state.errorMessage = '';
            return state;
        },
        [UserEditPassword.pending]: (state) => {
            state.isFetching = true;
        },
        [UserEditPassword.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }
    },
});

export const { clearStateEditPassword } = editPasswordSlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearStateEditPassword());
    }
}

export const editPasswordSelector = (state) => state.userEditPassword;

export default editPasswordSlice.reducer;
